import { render, staticRenderFns } from "./queryPointsDialog.vue?vue&type=template&id=7ec04afc&scoped=true"
import script from "./queryPointsDialog.vue?vue&type=script&lang=js"
export * from "./queryPointsDialog.vue?vue&type=script&lang=js"
import style0 from "./queryPointsDialog.vue?vue&type=style&index=0&id=7ec04afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec04afc",
  null
  
)

export default component.exports